import { useLocation, useParams } from 'react-router-dom';
import DetailPlanLinkLanding from './DetailPlanLinkLanding';

export const TOPIC_PLAN_LINK_PATH = 'topic-plan';

/**
 * Path inside the new Vizzle iframe that shows the topic detail plan page.
 * The query string (e.g. ?level=2) is passed through untouched so the page
 * opens at the instruction level encoded in the shared link.
 */
export const buildTopicDetailsPath = (topicId, search = '') => `/search-lessons/topic-details/${topicId}${search}`;

/**
 * Landing route for a shared topic "Detail Plan Link" (/topic-plan/:topicId?level=n).
 *
 * Topics are keyed by id everywhere, so no lookup is needed. Access and
 * not-found errors are handled by the topic page itself.
 */
export default function TopicPlanLink() {
  const { topicId } = useParams();
  const { search } = useLocation();

  const resolveTarget = async () => (topicId ? buildTopicDetailsPath(topicId, search) : null);

  return (
    <DetailPlanLinkLanding
      itemName='topic'
      returnPath={`/${TOPIC_PLAN_LINK_PATH}/${topicId}${search}`}
      resolveTarget={resolveTarget}
    />
  );
}
